/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_EInputs */

const cs_enum_e = /** @type {(inputs: Enum_EInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E`)
};

const en_enum_e = /** @type {(inputs: Enum_EInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E`)
};

/**
* | output |
* | --- |
* | "E" |
*
* @param {Enum_EInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_e = /** @type {((inputs?: Enum_EInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_EInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_e(inputs)
	return cs_enum_e(inputs)
});